import script from "./StarRate.vue?vue&type=script&setup=true&lang=ts"
export * from "./StarRate.vue?vue&type=script&setup=true&lang=ts"

import "./StarRate.vue?vue&type=style&index=0&id=360dbb82&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-360dbb82"]])

export default __exports__